import type { FC, ReactNode } from 'react'
import type { Product } from '@/types'

import { cn } from '@/lib/utils'
import { GrainArt, getGrainStyle } from '@/components/products/grain-art'

interface ProductVisualProps {
    product: Product
    eager?: boolean
    className?: string
}

/**
 * Shows the variety photo from the CMS, or a grain illustration until one is uploaded.
 */
export const ProductVisual: FC<ProductVisualProps> = ({ product, eager = false, className }): ReactNode => {
    if (product.image) {
        return (
            <img
                src={product.image}
                alt={product.image_alt || product.name}
                loading={eager ? 'eager' : 'lazy'}
                decoding='async'
                className={cn('size-full object-cover', className)}
            />
        )
    }

    return (
        <GrainArt
            seed={product.slug}
            {...getGrainStyle(product)}
            className={cn('size-full', className)}
        />
    )
}
